import React, { FunctionComponent } from 'react';
import cx from 'classnames';
import completeStyles from '../Complete/style.module.css';
import summaryStyles from '../Summary/style.module.css';

interface Props {
  type: 'summary' | 'complete';
  className?: string;
}

export const WrapperStoreData: FunctionComponent<Props> = ({ children, type, className }) => {
  const commonStyle =
    'br10 bg-white pt16 pr8 pb8 ph24-ns pb12-ns pt24-m pt24-l pr16-m pr16-l pb16-m pb16-l';
  const summaryStyle = 'pl12 pl24-m pl24-l b--abbey b--solid';
  const completeStyle =
    'flex flex-column flex-row-ns flex-column-m flex-column-l items-center-ns w-100';

  const styleByType = type === 'summary' ? summaryStyle : completeStyle;

  const wrapper = cx(
    commonStyle,
    styleByType,
    type === 'summary' ? summaryStyles.wrapperStoreData : completeStyles.wrapperStoreData,
    className,
  );

  return <div className={wrapper}>{children}</div>;
};
